import React from "react";

import {
    BooleanField,
    DateField,
    ImageField,
    NumberField,
    ReferenceField,
    RichTextField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField
} from "react-admin";

import {SelectCampaignStatusField} from "../../fields/SelectCampaignStatus";

const CampaignShow = (props) => (
    <Show {...props}>
        <TabbedShowLayout>
            <Tab label="Résumé pour liste">
                <TextField source="abstract_title" label="Titre"/>
                <ImageField source="abstract_image" label="Image" />
                <TextField source="abstract_content" label="Texte"/>
            </Tab>

            <Tab label="Page campagne">
                <TextField source="title" label="Titre"/>
                <ReferenceField label="Region" source="region_id" reference="region">
                    <TextField source="value"/>
                </ReferenceField>
                <ImageField source="background_image" label="Image header"/>
                <TextField source="copyright" label="Copyright"/>
                <RichTextField source="content" label="Contenu"/>
            </Tab>

            <Tab label="Créateur">
                <TextField source="campaign_creator_fullname" label="Prénom et nom"/>
                <TextField source="campaign_creator_entity_1" label="Fonction (ligne 1)"/>
                <TextField source="campaign_creator_entity_2" label="Fonction (ligne 2)"/>
                <ImageField source="campaign_creator_image" label="Portrait"/>
            </Tab>

            <Tab label="Configuration">
                <TextField source="url" label="URL de la page"/>
                <TextField source="meta_title" label="Titre pour le SEO"/>
                <BooleanField source="is_pinned" label="A la une"/>
                <NumberField source="goal" label="Objectif financier"/>
                <TextField source="origin_code" label="Code origine"/>
                <TextField source="affectation_code" label="Code affectation"/>
                <BooleanField source="is_doubled" label="Don doublé"/>
                <SelectCampaignStatusField source="status" label="Statut"/>
                <DateField source="start_date" label="Date de début"/>
                <DateField source="end_date" label="Date de fin"/>
            </Tab>
        </TabbedShowLayout></Show>
);

export default CampaignShow;
